<ng-container
  *ngFor="
    let timeTrackingWithFormGroup of timeTrackingsWithFormGroup$ | async;
    let i = index;
    trackBy: trackById
  ">
  <div
    class="row time-tracking__row"
    *ngIf="
      !(isPooler$ | async) ||
      ((isPooler$ | async) &&
        (timeTrackingWithFormGroup.timeTracking.toBeApprovedAt ||
          timeTrackingWithFormGroup.timeTracking.approvedAt))
    "
    (click)="stopPropagation($event)"
    [formGroup]="timeTrackingWithFormGroup.formGroup">
    <div class="col-sm-4">
      <mat-form-field class="light-form-field">
        <mat-label>{{ ("from" | i18n) || "von" | titlecase }}</mat-label>
        <input
          matInput
          type="time"
          name="from"
          formControlName="from"
          (ngModelChange)="
            updateTimeValue($event, i, isPooler ? 'from' : 'correctedFrom')
          "
          data-cy="time-tracking-from-input" />
        <mat-error
          class="input-error"
          *ngIf="timeTrackingWithFormGroup.formGroup.controls.from.invalid">
          {{ ("fieldRequiredError" | i18n) || "Field Required" }}
        </mat-error>
        <mat-hint
          *ngIf="
            timeTrackingWithFormGroup.timeTracking.correctedFrom !==
              undefined &&
            timeTrackingWithFormGroup.timeTracking.correctedFrom !=
              timeTrackingWithFormGroup.timeTracking.from &&
            timeTrackingWithFormGroup.timeTracking.toBeApprovedAt
          "
          class="adjusted"
          data-cy="time-tracking-from-previous-value">
          {{ timeTrackingWithFormGroup.timeTracking.from | time }}
        </mat-hint>
      </mat-form-field>
    </div>
    <div class="col-sm-4">
      <mat-form-field class="light-form-field">
        <mat-label>{{ ("to" | i18n) || "bis" | titlecase }}</mat-label>
        <input
          matInput
          type="time"
          name="to"
          formControlName="to"
          (ngModelChange)="
            updateTimeValue($event, i, isPooler ? 'to' : 'correctedTo')
          "
          data-cy="time-tracking-to-input" />
        <mat-error
          class="input-error"
          *ngIf="timeTrackingWithFormGroup.formGroup.controls.to.invalid">
          {{ ("fieldRequiredError" | i18n) || "Field Required" }}
        </mat-error>
        <mat-hint
          *ngIf="
            timeTrackingWithFormGroup.timeTracking.correctedTo !== undefined &&
            timeTrackingWithFormGroup.timeTracking.correctedTo !=
              timeTrackingWithFormGroup.timeTracking.to &&
            timeTrackingWithFormGroup.timeTracking.toBeApprovedAt
          "
          class="adjusted"
          data-cy="time-tracking-to-previous-value">
          {{ timeTrackingWithFormGroup.timeTracking.to | time }}
        </mat-hint>
      </mat-form-field>
    </div>
    <div class="col-sm-4">
      <mat-form-field class="light-form-field">
        <mat-label>{{ ("pause" | i18n) || "pause" | titlecase }}</mat-label>
        <input
          matInput
          type="time"
          name="pause"
          formControlName="pause"
          (ngModelChange)="
            updateTimeValue($event, i, isPooler ? 'pause' : 'correctedPause')
          "
          data-cy="time-tracking-pause-input" />
        <mat-hint
          *ngIf="
            timeTrackingWithFormGroup.timeTracking.correctedPause !==
              undefined &&
            timeTrackingWithFormGroup.timeTracking.correctedPause !=
              timeTrackingWithFormGroup.timeTracking.pause &&
            timeTrackingWithFormGroup.timeTracking.toBeApprovedAt
          "
          class="adjusted"
          data-cy="time-tracking-pause-previous-value">
          {{ timeTrackingWithFormGroup.timeTracking.pause | time }}
        </mat-hint>
      </mat-form-field>
    </div>
    <!-- Correction reason field for dispatchers only when there are adjustments -->
    <div
      class="col-12"
      *ngIf="
      (displayCorrectionReason(
        timeTrackingWithFormGroup.timeTracking,
        (job$ | async)?.shifts?.[i]
      ) ||
        timeTrackingWithFormGroup.timeTracking.correctionReason || 
        timeTrackingWithFormGroup.timeTracking.dispoCorrectionReason) &&
      !timeTrackingWithFormGroup.formGroup.disabled
    ">
      <mat-form-field class="light-form-field correction-reason-field">
        <mat-label>{{
          ("correctionReason" | i18n) || "Grund für Korrektur"
        }}</mat-label>
        <mat-hint
          *ngIf="
            !(isPooler$ | async) &&
            timeTrackingWithFormGroup.timeTracking.correctionReason
          "
          data-cy="time-tracking-correction-reason-hint-input">
          {{
            ("poolerCorrectionReason" | i18n) || "Grund für Korrektur (Pooler)"
          }}:
          {{ timeTrackingWithFormGroup.timeTracking.correctionReason }}
        </mat-hint>
        <textarea
          matInput
          [required]="
            !!(customer$ | async)?.timeTrackingDescriptionRequiredOnChange &&
            ((isPooler$ | async) ||
              (!(isPooler$ | async) &&
              displayCorrectionReason(
                timeTrackingWithFormGroup.timeTracking,
                (job$ | async)?.shifts?.[i]
              )))
          "
          name="correctionReason"
          formControlName="correctionReason"
          (ngModelChange)="updateCorrectionReason($event, i)"
          data-cy="time-tracking-correction-reason"></textarea>
      </mat-form-field>
    </div>
    <!-- Display correction reason to poolers when available -->
    <p
      class="col-12"
      class="correction-reason-label"
      *ngIf="
        timeTrackingWithFormGroup.timeTracking.correctionReason &&
        ((isPooler$ | async) ||
          (!(isPooler$ | async) &&
            timeTrackingWithFormGroup.formGroup.disabled))
      "
      data-cy="time-tracking-correction-reason-hint">
      {{ ("correctionReason" | i18n) || "Grund für Korrektur" }}:
      {{ timeTrackingWithFormGroup.timeTracking.correctionReason }}
      <br />
      {{ timeTrackingWithFormGroup.timeTracking.dispoCorrectionReason }}
    </p>
  </div>
</ng-container>

<ng-container *ngIf="timeTrackingsWithFormGroup$ | async as trackings">
  <ng-container *ngIf="trackings.length > 0">
    <div
      class="time-tracking__total text-align-right"
      *ngIf="
        !(isPooler$ | async) ||
        ((isPooler$ | async) && hasAnyApprovedOrToBeApproved(trackings))
      ">
      {{ ("total" | i18n) || "Total" | titlecase }}:&nbsp;
      <span data-cy="time-tracking-total-display">
        {{ (timeTrackingTotal$ | async) ?? 0 | time: true }}
      </span>
    </div>
    <div class="time-tracking__action-buttons">
      <button
        *ngIf="
          !(isMagicLink$ | async) &&
          !(isPooler$ | async) &&
          (invitee$ | async)?.customerTimeTrackingSecret &&
          (canSubmitTimeTrackings$ | async)
        "
        class="outline-pill-button icon-left"
        type="button"
        (click)="generateLink($event)"
        data-cy="time-tracking-save-button">
        <mat-icon svgIcon="link-add"></mat-icon>
        {{ ("createLink" | i18n) || "Link generieren" | titlecase }}
      </button>
      <button
        class="outline-pill-button icon-left"
        type="button"
        *ngIf="
        !((timeTrackingsWithFormGroup$ | async)?.[0]?.timeTracking?.toBeApprovedAt) && 
        (canSubmitTimeTrackings$ | async) &&
        !(isPooler$ | async)
      "
        [disabled]="
          (timeTrackingsFormArray$ | async)?.invalid ||
          ((timeTrackingTotal$ | async) ?? 0) < 0 ||
          !(canApproveHours$ | async)
        "
        (click)="setToBeApproved($event)"
        data-cy="time-tracking-submit-button">
        <mat-icon svgIcon="clock-forward"></mat-icon>
        {{ "submitTimeTracking" | i18n }}
      </button>
      <button
        class="outline-pill-button icon-left"
        type="button"
        *ngIf="canOpenSigningStepper$ | async"
        (click)="openSigningStepper()"
        data-cy="time-tracking-open-stepper-button">
        <mat-icon svgIcon="check"></mat-icon>
        <ng-container
          *ngIf="(timeTrackingsWithFormGroup$ | async)?.[0]?.timeTracking?.toBeApprovedAt; else submitLabel">
          {{ "requestSignature" | i18n }}
        </ng-container>
        <ng-template #submitLabel>
          {{ ("submitTimeTracking" | i18n) || ("requestSignature" | i18n) }}
        </ng-template>
      </button>
      <button
        class="outline-pill-button icon-left"
        type="button"
        [disabled]="
          (timeTrackingsFormArray$ | async)?.invalid ||
          ((timeTrackingTotal$ | async) ?? 0) < 0 ||
          !(canApproveHours$ | async)
        "
        *ngIf="
        !(isPooler$ | async) &&
        ((timeTrackingsWithFormGroup$ | async)?.[0]?.timeTracking?.toBeApprovedAt) && !((timeTrackingsWithFormGroup$ | async)?.[0]?.timeTracking?.approvedAt)
      "
        (click)="setApproved($event)"
        data-cy="time-tracking-approve-button">
        <mat-icon svgIcon="check"></mat-icon>
        {{ "approveHours" | i18n }}
      </button>
    </div>
    <mat-error
      class="input-error"
      *ngIf="
        (timeTrackingsFormArray$ | async)?.invalid ||
        ((timeTrackingTotal$ | async) ?? 0) < 0
      ">
      <ng-container *ngIf="timeTrackingsFormArray$ | async as formArray">
        {{ formArray.errors?.message | i18n }}
      </ng-container>
    </mat-error>
  </ng-container>
</ng-container>

<ng-container
  *ngIf="signingStepperOpen && (invitee$ | async) && (job$ | async)">
  <app-time-tracking-stepper
    [invitee]="(invitee$ | async)!"
    [job]="(job$ | async)!"
    [timeTrackingValues]="(timeTrackingsWithFormGroupForStepper$ | async) || []"
    [magicSecret]="magicSecret"
    (closeSheet)="signingStepperOpen = false"
    (timeTrackingSubmitted)="onTimeTrackingSubmitted($event)"
    (signatureSubmitted)="
      onSignatureSubmitted($event)
    "></app-time-tracking-stepper>
</ng-container>
